<div fxLayout="row" fxLayoutAlign="start center" class="iot-platform-ui-overview-shell">
  <div #backButton (click)="onReturnButtonClicked()" class="origin" fxFlex fxLayoutAlign="center center">
    <mat-icon>keyboard_backspace</mat-icon>
  </div>

  <iot-platform-ui-toolbar-v2 class="iot-platform-ui-overview-shell__toolbar"
    (dispatchToolbarEvent)="onToolbarEvent($event)"
    [breadCrumbConfiguration]="breadCrumbConfiguration()"
    [buttonList]="buttonList()"
    [name]="name()"
    [size]="ToolbarSize.SMALL"
    fxFlex
  >
    <div toolbarBreadCrumbMeta>
      <ng-content select="[breadcrumbMeta]" />
    </div>
  </iot-platform-ui-toolbar-v2>
</div>

<mat-sidenav-container fxFlex class="iot-platform-ui-overview-shell__sidenav-container" [hasBackdrop]="true" (backdropClick)="onBackdropClick()">
  <!-- <mat-sidenav-content class="iot-platform-ui-overview-shell__sidenav-content" [style.width]="sideNavContentWidth()"> -->
  <mat-sidenav-content class="iot-platform-ui-overview-shell__sidenav-content">
    <ng-content select="[overviewContent]" />
  </mat-sidenav-content>
  <mat-sidenav #sidePanel class="iot-platform-ui-overview-shell__sidenav" [mode]="isXSmallScreen() ? 'over' : 'over'" position="end" [opened]="sidenavOpened()"  [style.width]="drawerWidth()">
    <ng-content select="[overviewSidePanel]" />

    <iot-platform-ui-resize-handle
      [parentContainerSelector]="'.iot-platform-ui-overview-shell'"
      [pageName]="pageName()"
      [defaultWidth]="'25rem'"
      [minWidth]="'25rem'"
      [maxWidth]="'50%'"
      [resizable]="true"
      [position]="'end'"
      [resizeElementOpened]="sidenavOpened()"
      (contentWidth)="sideNavContentWidth.set($event)"
      (width)="drawerWidth.set($event)"
    />
  </mat-sidenav>
</mat-sidenav-container>
